module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0051.7e16d4b8.jpg";